export const FETCH_COUNTRY_STORES_LIST = 'FETCH_COUNTRY_STORES_LIST'
export const FETCH_COUNTRY_STORES_LIST_SUCCESS = 'FETCH_COUNTRY_STORES_LIST_SUCCESS'
export const FETCH_COUNTRY_STORES_LIST_ERROR = 'FETCH_COUNTRY_STORES_LIST_ERROR'

export const FETCH_ALL_STORES = 'FETCH_ALL_STORES'
export const FETCH_ALL_STORES_SUCCESS = 'FETCH_ALL_STORES_SUCCESS'
export const FETCH_ALL_STORES_ERROR = 'FETCH_ALL_STORES_ERROR'

export const FETCH_COUNTRY_CLUSTERS = 'FETCH_COUNTRY_CLUSTERS'
export const FETCH_COUNTRY_CLUSTERS_SUCCESS = 'FETCH_COUNTRY_CLUSTERS_SUCCESS'
export const FETCH_COUNTRY_CLUSTERS_ERROR = 'FETCH_COUNTRY_CLUSTERS_ERROR'

export const FETCH_ECOM_CLUSTERS = 'revenue/FETCH_ECOM_CLUSTERS'
export const FETCH_ECOM_CLUSTERS_SUCCESS = 'revenue/FETCH_ECOM_CLUSTERS_SUCCESS'
export const FETCH_ECOM_CLUSTERS_ERROR = 'revenue/FETCH_ECOM_CLUSTERS_ERROR'

export const FETCH_ALL_CLUSTERS = 'FETCH_ALL_CLUSTERS'
export const FETCH_ALL_CLUSTERS_SUCCESS = 'FETCH_ALL_CLUSTERS_SUCCESS'
export const FETCH_ALL_CLUSTERS_ERROR = 'FETCH_ALL_CLUSTERS_ERROR'

export const FETCH_STORE_DETAILS = 'FETCH_STORE_DETAILS'
export const FETCH_STORE_DETAILS_SUCCESS = 'FETCH_STORE_DETAILS_SUCCESS'
export const FETCH_STORE_DETAILS_ERROR = 'FETCH_STORE_DETAILS_ERROR'

export const FETCH_GENERAL_REVENUE = 'FETCH_GENERAL_REVENUE'
export const FETCH_GENERAL_REVENUE_SUCCESS = 'FETCH_GENERAL_REVENUE_SUCCESS'
export const FETCH_GENERAL_REVENUE_ERROR = 'FETCH_GENERAL_REVENUE_ERROR'

export const CHANGE_DATA_SORTING = 'CHANGE_DATA_SORTING'

export const FILTER_BY_CLUSTER = 'FILTER_BY_CLUSTER'

export const CHECK_REVENUE_FOR_TODAY = 'revenue/CHECK_REVENUE_FOR_TODAY'

export const EXPAND_COUNTRY = 'revenue/EXPAND_COUNTRY'

export const SET_SUMMARY_STORE_TYPE = 'revenue/SET_SUMMARY_STORE_TYPE'
export const SET_SUMMARY_FILTER = 'revenue/SET_SUMMARY_FILTER'
